


















import { Component, Vue } from "vue-property-decorator";

import blockedClientModel from "@/api/blocked_client.model";
import EntityCrud from "../entity/EntityCrud.vue";
import EntityForm from "../entity/EntityForm.vue";

@Component({
	components: { EntityCrud, EntityForm },
})
export default class BlockedClients extends Vue {
	model: any = blockedClientModel;
	creationRoute = "cliente-bloqueio/novo";
	title = "Clientes bloqueados";
	kind = "blockedClientsTable";
	withEntityHeader = true;
	tableColumns = [
		{ name: "CPF", key: "cpf" },
		{ name: "Telefone com DDD", key: "phoneNumber" },
	];

	onRowClick = (id: string) => this.$router.push(`cliente-bloqueio/${id}`);

	exportColumns = [{ key: "cpf" }, { key: "phoneNumber", name: "Telefone com DDD" }];

	formColumns = [
		{ key: "cpf", required: false },
		{ key: "phoneNumber", required: false },
	];
}
